export default "__VITE_ASSET__8876ebe5__"